import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;
  switch(action.type) {
    case types.SET_PASSWORD_SUCCESS:
      if(response.status===200) {
        return { 
          status: response.status,
          activity: types.SET_PASSWORD_SUCCESS,
          ...state, 
          response 
        };
      }
      else {
        return { 
          status: response.status,
          activity: types.SET_PASSWORD_ERROR,
          ...state, 
          response 
        };
      }
    case types.SET_PASSWORD_ERROR:
      return { 
        status: response.status,
        activity: types.SET_PASSWORD_ERROR,
        ...state, 
        response 
      };
    default:
      return state;
  }
};